import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { getBoardInvitations } from '../requests';
import type { GetBoardInvitationsRequestParams } from '../types';

export const useGetBoardInvitations = ({
  path: { organisationId, boardId },
}: GetBoardInvitationsRequestParams) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.boardInvitations, { organisationId, boardId }],
    queryFn: () => getBoardInvitations({ path: { organisationId, boardId } }),
  });
